import { useMemo } from "react";
import { ExternalConnectionListRequest, useListExternalConnectionsQuery } from "../api/externalConnections";
import { isExternalConnectionLinkJudiCare } from "../utils/externalConnections";

export const useListCategorizedExternalConnectionList = (body: ExternalConnectionListRequest) => {
  const { data, isLoading } = useListExternalConnectionsQuery(body);

  const output = useMemo(() => {
    const externalConnectionsGeneral = [];
    const externalConnectionsJudiCare = [];

    if (!isLoading && data) {
      for (const result of data.results) {
        if (isExternalConnectionLinkJudiCare(result.link)) {
          externalConnectionsJudiCare.push(result);
        } else {
          externalConnectionsGeneral.push(result);
        }
      }
    }

    return {
      externalConnectionsJudiCare,
      externalConnectionsGeneral,
    };
  }, [data, isLoading]);

  return { ...output, isLoading };
};
